<template>
  <div class="bg">
    <div class="header">
      <div class="left">
        <div class="info" @click="backHome()">
          <img class="img" title="首页" src="@/assets/img/logo/logo-txt.png" />
          <!-- <div class="txt">双重预防体系云平台</div> -->
        </div>
      </div>
      <div class="center">鹤壁市校园防欺凌平台</div>
      <div class="right"></div>
    </div>
    <div class="content">
      <div class="center">
        <!-- <BaiduMap class="map" :schoolList="schoolList"></BaiduMap> -->
        <map-echarts
          class="map"
          :schoolList="schoolList"
        ></map-echarts>
      </div>
      <div class="left">
        <div class="month">
          <div class="chart-title">报警数量月份统计</div>
          <monthLine
            v-if="monthList.length"
            :echartsData="monthList"
          ></monthLine>
        </div>
        <div class="event">
          <div class="chart-title">上周数据统计</div>
          <event-type :echartsData="weekEvent"></event-type>
        </div>
        <div class="rate">
          <div class="chart-title">上周学校响应率排名</div>
          <school-rate :weekRate="weekRate.rate"></school-rate>
        </div>
      </div>
      <div class="right">
        <div class="new">
          <div class="chart-title">最新事件列表</div>
          <event-list :dataList="newRes.data"></event-list>
        </div>
        <div class="handle">
          <div class="chart-title">未处理事件列表</div>
          <event-list :dataList="handleRes.data"></event-list>
        </div>
        <div class="bully">
          <div class="chart-title">欺凌事件列表</div>
          <event-list :dataList="bullyRes.data"></event-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaiduMap from "./components/mapInfo.vue";
import mapEcharts from "./components/mapEcharts.vue";
import MonthLine from "./components/hiddenDangerStatistic";
import EventType from "./components/unsafeTypeEcharts";
import SchoolRate from "./components/schoolRate";
import EventList from "./components/eventList";
export default {
  name: "",
  components: {
    BaiduMap,
    mapEcharts,
    MonthLine,
    EventType,
    SchoolRate,
    EventList
  },
  data() {
    return {
      schoolList: [],
      monthList: [],
      weekEvent: [],
      weekRate: {
        rate: []
      },
      newReq: {
        pageNumber: 1,
        pageSize: 50
      },
      newRes: {
        data: []
      },
      handleReq: {
        pageNumber: 1,
        pageSize: 50
      },
      handleRes: {
        data: []
      },
      bullyReq: {
        pageNumber: 1,
        pageSize: 50
      },
      bullyRes: {
        data: []
      }
    };
  },
  created() {
    this.getSchoolList();
    this.getMonthEvent();
    this.getWeekEvent();
    this.getWeekEventRate();
    this.getEventNew();
    this.getEventUnHandle();
    this.getEventBully();

    setInterval(() => {
      // console.log(1);
      this.getEventNew();
      this.getEventUnHandle();
      this.getEventBully();
    }, 180000);
  },
  methods: {
    async getSchoolList() {
      let req = {};
      let res = await this.$httpFenYin.getSchoolList(req);
      // console.log(res);
      if (res.code == 0) {
        let schoolList = res.data.map((item) => {
          return {
            address_des: item.address_des,
            area: item.area,
            city: item.city,
            company_lon: item.company_lon,
            company_lat: item.company_lat,
            created_at: item.created_at,
            device_count: item.device_count,
            province: item.province,
            school_name: item.school_name,
            showInfoWindow: false
          };
        });
        this.schoolList = schoolList;
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    async getMonthEvent() {
      let req = {};
      let res = await this.$httpFenYin.getMonthEvent(req);
      // console.log(res);
      if (res.code == 0) {
        // console.log(res.data);
        this.monthList = res.data || [];
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    async getWeekEvent() {
      let req = {};
      let res = await this.$httpFenYin.getWeekEvent(req);
      // console.log(res);
      if (res.code == 0) {
        let data = [
          {
            name: "玩闹",
            value: res.data.play_count
          },
          {
            name: "谩骂冲突",
            value: res.data.rail_count
          },
          {
            name: "欺凌",
            value: res.data.clash_count
          },
          {
            name: "误报",
            value: res.data.false_count
          },
          {
            name: "不确定",
            value: res.data.uncertain_count
          }
        ];

        this.weekEvent = data;
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    async getWeekEventRate() {
      let req = {};
      let res = await this.$httpFenYin.getWeekEventRate(req);
      // console.log(res);
      if (res.code == 0) {
        this.weekRate = res.data;
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    async getEventNew() {
      let req = this.newReq;
      let res = await this.$httpFenYin.getEventNew(req);
      // console.log(res);
      if (res.code == 0) {
        if (res.data.data != "") {
          this.newRes = res.data;
        } else {
          this.bullyRes = {
            data: []
          };
        }
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    async getEventUnHandle() {
      let req = this.handleReq;
      this.isLoading = true;
      let res = await this.$httpFenYin.getEventUnHandle(req);
      this.isLoading = false;
      // console.log(res);
      if (res.code == 0) {
        if (res.data.data != "") {
          this.handleRes = res.data;
        } else {
          this.bullyRes = {
            data: []
          };
        }
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    async getEventBully() {
      let req = this.bullyReq;
      let res = await this.$httpFenYin.getEventBully(req);
      // console.log(res);
      if (res.code == 0) {
        if (res.data.data != "") {
          this.bullyRes = res.data;
        } else {
          this.bullyRes = {
            data: []
          };
        }
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  }
};

var targetHeightScale; //存放缩放的比例
var autoResize = {
  resize: function(docWidth, docHeight, targetSelector) {
    var docScale = docHeight / docWidth,
      designWidth = 1920,
      designHeight = 940,
      els = document.querySelectorAll(targetSelector),
      scale = docWidth / designWidth,
      scaleX = docWidth / designWidth,
      scaleY = docHeight / designHeight,
      _this = this;
    (targetHeightScale = scale), //将缩放比例保存，动态计算宽高时需要使用
      this.convertArray(els).forEach(function(el) {
        _this.extend(el.style, {
          width: designWidth + "px",
          height: docScale * designWidth + "px",
          position: "absolute",
          top: 0,
          left: 0,
          transformOrigin: "0 0",
          webkitTransformOrigin: "0 0",
          transform: "scale(" + scale + ")",
          webkitTransform: "scale(" + scale + ")",
          overflow: "hidden",
          webkitOverflowScrolling: "touch"
        });
      });
  },
  convertArray: function(arrayLike) {
    return Array.prototype.slice.call(arrayLike, 0);
  },
  extend: function() {
    var args = Array.prototype.slice.call(arguments, 0);
    return args.reduce(function(prev, now) {
      for (var key in now) {
        if (now.hasOwnProperty && now.hasOwnProperty(key)) {
          prev[key] = now[key];
        }
      }
      return prev;
    });
  },
  scaleResize: function(clientWidth, clientHeight, targetSelector) {
    window.addEventListener(
      "resize",
      this.resize(clientWidth, clientHeight, targetSelector)
    ); //监听窗口的变化
  }
};
var setElementSize = {
  //参数可选，最多选择5个参数。参数按序赋值，如果不需缩放，scale需传入1
  setSize: function(target, scale, target1, target2, target3) {
    var targetScale = scale || 1; //不传scale，不缩放，默认为1
    var targetHeight;
    if (target) {
      targetHeight = innerHeight / targetScale;
    }
    // console.log(targetHeight)
    // if (target1) {
    //     targetHeight = window.height() / targetScale -  document.querySelector(target1).height();
    // }
    // if (target1 && target2 && target3) {
    //     targetHeight = window.height() / targetScale -  document.querySelector(target1).height() -  document.querySelector(target2).height() -  document.querySelector(target3).height();
    // } else if (target1 && target2) {
    //     targetHeight = window.height() / targetScale -  document.querySelector(target1).height() -  document.querySelector(target2).height();
    // } else if (target1) {
    //     targetHeight = window.height() / targetScale -  document.querySelector(target1).height();
    // }
    document.querySelector(".bigdata_page").style.height = targetHeight;

    // var cancas =  document.getElementsByTagName('canvas')
    // var ss = document.getElementsByTagName('canvas')

    // console.log(ss)

    // document.getElementsByTagName('canvas').setAttribute('height','100%')
    // document.getElementsByTagName('canvas').setAttribute('width','100%')
    // console.log(cancas)
    // cancas.width = '100px'
    // cancas.height = '100px'

    // console.log(123)
    // console.log(document.querySelector('.bigdata_page').offsetHeight)
  }
};
var is_fullScreen = false;

window.onresize = function() {
  if (is_fullScreen) {
    changeHeight();
  } else {
    cancelChangeHeight();
  }
  autoResize.scaleResize(innerWidth, innerHeight, ".bigdata_page");
  setElementSize.setSize(".bigdata_page", targetHeightScale);
  // setElementSize.setSize('.left_top', targetHeightScale, '.top')
  // setElementSize.setSize('.map', targetHeightScale, '.top', '.left_bottom');
  // setElementSize.setSize('.right_body', targetHeightScale, '.top');
};
autoResize.scaleResize(innerWidth, innerHeight, ".bigdata_page");
setElementSize.setSize(".bigdata_page", targetHeightScale);
// 全屏状态时更改高度
function changeHeight() {
  is_fullScreen = true;
}

// 取消全屏时恢复
function cancelChangeHeight() {
  is_fullScreen = false;
}
</script>

<style lang="scss" scoped>
.bg {
  padding-top: 110px;
  width: 100%;
  height: 100%;
  background: url("~@/assets/img/schoolBigData2/bg.png") center center no-repeat;
  background-size: 100% 100%;
  min-width: 1200px;
  min-height: 768px;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 90px;
  padding: 0 40px;
  background: transparent;
  box-shadow: 0px 0px 2px 1px #202e7e;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  .left {
    height: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .info {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      // cursor: pointer;
      // transition: all 0.3s;
      // &:hover {
      //   transform: scale(1.05);
      // }
      .img {
        width: 107px;
        height: 48px;
      }
      .txt {
        margin-top: 7px;
        font-size: 18px;
        font-weight: 400;
        color: #86bb4f;
        font-style: italic;
      }
    }
  }
  .center {
    font-size: 26px;
    font-family: YouSheBiaoTiHei;
    font-weight: 600;
    color: #86bb4f;
  }
  .right {
    width: 107px;
  }
}
.content {
  width: 100%;
  height: 100%;
  background: transparent;
  position: relative;
  z-index: 5;
  .center {
    display: flex;
    justify-content: center;
    // align-items: center;
    width: 100%;
    height: 100%;
    .map {
      width: 760px;
      height: 800px;
    }
  }
  .left {
    position: absolute;
    top: 0px;
    left: 10px;
    z-index: 999;
    .month {
      width: 550px;
      height: 240px;
      background: url("~@/assets/img/riskHidden2/left-bottom.png") center center
        no-repeat;
      background-size: 100% 100%;
      .chart-title {
        padding: 12px 0 0 18px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #6ff3fa;
      }
    }
    .event {
      margin-top: 10px;
      width: 550px;
      height: 240px;
      background: url("~@/assets/img/riskHidden2/left-bottom.png") center center
        no-repeat;
      background-size: 100% 100%;
      .chart-title {
        padding: 12px 0 0 18px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #6ff3fa;
      }
    }
    .rate {
      margin-top: 10px;
      width: 550px;
      height: 300px;
      background: url("~@/assets/img/riskHidden2/left-bottom.png") center center
        no-repeat;
      background-size: 100% 100%;
      .chart-title {
        padding: 12px 0 0 18px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #6ff3fa;
        position: relative;
        top: 4px;
      }
    }
  }
  .right {
    position: absolute;
    top: 0px;
    right: 10px;
    z-index: 999;
    .new {
      width: 550px;
      height: 258px;
      background: url("~@/assets/img/riskHidden2/left-bottom.png") center center
        no-repeat;
      background-size: 100% 100%;
      .chart-title {
        padding: 12px 0 0 18px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #6ff3fa;
        position: relative;
        top: 1px;
      }
    }
    .handle {
      margin-top: 13px;
      width: 550px;
      height: 258px;
      background: url("~@/assets/img/riskHidden2/left-bottom.png") center center
        no-repeat;
      background-size: 100% 100%;
      .chart-title {
        padding: 12px 0 0 18px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #6ff3fa;
        position: relative;
        top: 1px;
      }
    }
    .bully {
      margin-top: 13px;
      width: 550px;
      height: 258px;
      background: url("~@/assets/img/riskHidden2/left-bottom.png") center center
        no-repeat;
      background-size: 100% 100%;
      .chart-title {
        padding: 12px 0 0 18px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #6ff3fa;
        position: relative;
        top: 1px;
      }
    }
  }
}
</style>
